import { useState } from "react"
import { useHistory } from "react-router-dom"
import { login } from "../actions"
import { Box } from "@material-ui/core"

export default function Login() {
  const history = useHistory()

  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")

  const loginClick = async () => {
    const loginData = await login(username, password)
    if (loginData?.user?.admin) {
      history.push("/")
    }
  }

  return (
    <Box display="flex" flexDirection="row" justifyContent="center" sx={{ width: "100%" }}>
      <Box display="flex" flexDirection="column" alignItems="stretch" sx={{ gridRowGap: "8px" }}>
        <h1>Smerf ADMIN</h1>
        <input placeholder="Username" onChange={e => setUsername(e.target.value)} />
        <input placeholder="Password" type="password" onChange={e => setPassword(e.target.value)} />
        <button onClick={loginClick}>Login</button>
      </Box>
    </Box>
  )
}
